module.exports = __webpack_public_path__ + "c74ad6a5a4fe6efe5d59098ce9bf6ada.pdf";